/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit1_TInputs */

const en_formatter_pit1_t = /** @type {(inputs: Formatter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab indentation is not the same as one space`)
};

const ko_formatter_pit1_t = /** @type {(inputs: Formatter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탭 들여쓰기는 한 칸 공백과 다릅니다`)
};

const ja_formatter_pit1_t = /** @type {(inputs: Formatter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タブインデントは 1 スペースとは違います`)
};

/**
* | output |
* | --- |
* | "Tab indentation is not the same as one space" |
*
* @param {Formatter_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit1_t = /** @type {((inputs?: Formatter_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit1_t(inputs)
	if (locale === "ko") return ko_formatter_pit1_t(inputs)
	return ja_formatter_pit1_t(inputs)
});